module.exports = __webpack_public_path__ + "img/KUCE-02.b7918868.png";